module.exports = __webpack_public_path__ + "static/media/keyrisk-logo.b9858ac4.png";